import React, { useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import BuyManagerSelector from './BuyManagerSelector.jsx'; 
import AppContext from '../../../../../context/AppProvider.jsx';
import { selectAllBuyManagers } from '../../../../../store/slices/buyManager/buyManagers.js';
import { selectSelectedBuyManagers, setSelectedBuyManagers } from '../../../../../store/slices/swarmsInAction/index.js';
import { useDispatch } from 'react-redux';
import { selectCurrentUserId } from '../../../../../features/auth/authSlice.js';

const STORAGE_KEY = 'selectedBuyManagers';

const BuyManagerSelectorWrapper = () => {
  const buyManagers = useSelector(selectAllBuyManagers);
  const userId = useSelector(selectCurrentUserId);
  const selectedBuyManagers = useSelector(selectSelectedBuyManagers);
  let dispatch = useDispatch();

  useEffect(() => {
    if (buyManagers) {
      // Try to get saved buy managers from localStorage
      const savedBuyManagers = localStorage.getItem(STORAGE_KEY);
      
      if (savedBuyManagers) {
        try {
          const parsedBuyManagers = JSON.parse(savedBuyManagers);
          if(parsedBuyManagers && parsedBuyManagers.length == 1 && parsedBuyManagers[0] === 'showAll'){
            dispatch(setSelectedBuyManagers(['showAll']));
            return;
          }
          // Verify that the saved buy managers still exist in the current buyManagers list
          const validBuyManagers = parsedBuyManagers.filter(id => 
            buyManagers.some(bm => bm.buyManagerID === id)
          );
          if (validBuyManagers.length > 0) {
            dispatch(setSelectedBuyManagers(validBuyManagers));
            return;
          }
        } catch (error) {
          console.error('Error parsing saved buy managers:', error);
          // Remove corrupted data from localStorage
          localStorage.removeItem(STORAGE_KEY);
        }
      }
      
      // Default behavior: use user's buy manager
      const userBuyManager = buyManagers.find(bm => bm.encoreHiveId === userId);
      if (userBuyManager) {
        const defaultSelection = [userBuyManager.buyManagerID];
        dispatch(setSelectedBuyManagers(defaultSelection));
        // Save default selection to localStorage
        localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultSelection));
      }else{
        // No user's buy manager found, automatically select 'Show All' option
        const defaultSelection = ['showAll'];
        dispatch(setSelectedBuyManagers(defaultSelection));
        // Save default selection to localStorage
        localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultSelection));
      }
    }
  }, [buyManagers, dispatch, userId]);

  const handleSelectionChange = (selectedIds) => {
    // Update Redux state
    dispatch(setSelectedBuyManagers(selectedIds));
    
    // Save to localStorage
    if (selectedIds) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(selectedIds));
    }
  };

  return (
    <BuyManagerSelector
      buyManagers={buyManagers}
      selectedBuyManagers={selectedBuyManagers}
      setSelectedBuyManagers={handleSelectionChange}
      userId={userId}
    />
  );
};

export default BuyManagerSelectorWrapper;
